import React from 'react';

var LobbyFooter = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'pgc-lobby-footer' },
        React.createElement("div", { className: 'pgc-lobby-footer-inner' },
            React.createElement("div", { className: 'pgc-lobby-footer-scrollable' }, children))));
};

export { LobbyFooter };
